<template>
    <div class="sl-card inline-block float-right">
        <!-- Order Action Buttons -->
        <div class="sl-card-buttons">
            <!-- Delete Order -->
            <mdi-icon
                v-if="deletionRequested"
                icon="mdiDeleteClock"
                class="sl-card-button text-yellow-500 cursor-default"
            />

            <mdi-icon
                v-else-if="canDeleteOrder"
                icon="mdiDelete"
                class="sl-card-button text-red-500"
                @click="deleteConfirmationOpen = true"
            />

            <mdi-icon
                v-else
                icon="mdiDelete"
                class="sl-card-button sl-card-button--disabled"
            />
        </div>

        <teleport to="body">
            <lsn-modal
                :is-open="deleteConfirmationOpen"
                @keydown.esc="deleteConfirmationOpen = false"
            >
                <div class="sl-prompt sl-prompt--danger">
                    <div class="sl-prompt__contents">
                        <div class="sl-prompt__title">
                            {{ $t('order_edition.deletion_confirmation') }}
                        </div>

                        <div class="sl-prompt__text">
                            {{ $t('common.action_irreversible') }}
                        </div>
                    </div>

                    <div class="sl-prompt__actions">
                        <button
                            class="sl-prompt__button sl-prompt__button--white"
                            @click.stop="deleteConfirmationOpen = false"
                        >
                            {{ $t('common.cancel') }}
                        </button>

                        <button
                            ref="removeBtn"
                            class="sl-prompt__button sl-prompt__button--red"
                            @click.stop="remove"
                        >
                            {{ $t('common.remove') }}
                        </button>
                    </div>
                </div>
            </lsn-modal>
        </teleport>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import constants from '@/constants/constants';

// ------------------------------------------------------------ PROPS & EMITS

const props = defineProps({
    order:
    {
        type:     Object,
        required: true,
    },
});

const emit = defineEmits(['remove']);

// ------------------------------------------------------------ DATA

const deleteConfirmationOpen = ref(false);

// ------------------------------------------------------------ COMPUTED

const status = computed(() => props.order.status.at(-1)); // last status

const canDeleteOrder = computed(() => ![
    constants.orders.status.WAITING_FOR_SHIPPING,
    constants.orders.status.SHIPPED,
].includes(status.value.code));

const deletionRequested = computed(
    () => props.order.extra.deletion_requested == '1'
);

const deletionRequestLinkClass = computed(() => ({
    'lsn-loader-link--danger':   !deletionRequested.value,
    'lsn-loader-link--disabled': deletionRequested.value,
}));

// ------------------------------------------------------------ METHODS

function remove()
{
    emit('remove', props.order);
    deleteConfirmationOpen.value = false;
}
</script>
